import { Injectable } from "@angular/core";
import { Action, NgxsOnInit, State, StateContext } from "@ngxs/store";
import { HttpClient } from "@angular/common/http";
import { createRequestAction, RequestState } from "ngxs-requests-plugin";

import { environment } from "../../../../environments/environment";
import { AppConfigService } from "../../services/app-config.service";
import { AddSelectedVariables, RemoveSelectedVariables, ClearSelectedVariables, SaveVariablesPreset, SaveVariablesPresetFail, SaveVariablesPresetSuccess } from "./selected-variables.actions";
import { LocalStorageService } from "../../services/local-storage.service";

export interface SelectedVariablesStateModel {
  tags: string[],
}

@RequestState('saveVariablesPreset')
@Injectable()
export class SaveVariablesPresetRequestState {}


@State<SelectedVariablesStateModel>({
  name: 'selectedVariables',
  defaults: {
    tags: [],
  }
})
@Injectable()
export class SelectedVariablesState implements NgxsOnInit{

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private appConfig: AppConfigService,
  ) {}

  // On app init, load selected variables from local storage
  ngxsOnInit(ctx: StateContext<SelectedVariablesStateModel>) {
    const localStorageSelectedVariables = this.localStorageService.selectedVariablesSubject$.getValue();
    if (localStorageSelectedVariables && localStorageSelectedVariables.length > 0) {
      ctx.dispatch(new AddSelectedVariables(localStorageSelectedVariables, true));
    }
  }

  @Action(AddSelectedVariables)
  addSelectedVariables(
    ctx: StateContext<SelectedVariablesStateModel>,
    { payload: variablesToAdd, replace: replace }: AddSelectedVariables
  ) {
    const state = ctx.getState();   
    if (replace) {ctx.setState({ tags: variablesToAdd});}
    else {
      const newTags = new Set([...state.tags, ...variablesToAdd]);
      ctx.setState({ tags: Array.from(newTags)});
    }
  }

  @Action(RemoveSelectedVariables)
  removeSelectedVariables(
    ctx: StateContext<SelectedVariablesStateModel>,
    { payload: variablesToRemove }: RemoveSelectedVariables
  ) {
    const state = ctx.getState();
    const newTags = state.tags.filter(tag => !variablesToRemove.includes(tag));
    ctx.setState({ tags: newTags});
  }

  @Action(ClearSelectedVariables)
  clearSelectedVariables(
    ctx: StateContext<SelectedVariablesStateModel>,
  ) {
    ctx.setState({ tags: []});
  }

  @Action(SaveVariablesPreset)
  saveVariablesPreset(
    { dispatch, getState }: StateContext<SelectedVariablesStateModel>,
    { name: name, variables: variables}: SaveVariablesPreset
  ) {
    const body = {
      dbName: this.appConfig.dbName,
      dbVersion: "latest",
      name,
      variables
    };
    const request = this.http.post(environment.api + 'user/presets/variables/post', body);

    return dispatch(
      createRequestAction({
        request,
        state: SaveVariablesPresetRequestState,
        successAction: SaveVariablesPresetSuccess,
        failAction: SaveVariablesPresetFail
      })
    );
  }
  
  @Action(SaveVariablesPresetSuccess)
  saveVariablesPresetSuccess(
    ctx: StateContext<SelectedVariablesStateModel>,
    { payload: response }: SaveVariablesPresetSuccess
  ) {
  }

}